"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ValueWithUnitConverter_1 = require("../../core/conversions/ValueWithUnitConverter");

var EntityStateFlag_1 = require("../../core/model/EntityStateFlag");

var Supply_1 = require("../model/Supply");

var SupplyConverter_1 = require("./SupplyConverter");
/**
 *
 * Implementation of {@link SupplyConverter}
 *
 * @author RV
 * @author JMe
 */


var SupplyConverterImpl =
/*#__PURE__*/
function (_SupplyConverter_1$Su) {
  _inherits(SupplyConverterImpl, _SupplyConverter_1$Su);

  function SupplyConverterImpl() {
    _classCallCheck(this, SupplyConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(SupplyConverterImpl).apply(this, arguments));
  }

  _createClass(SupplyConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new Supply_1.Supply(Supply_1.Supply.schema.id.valueOf(conversions.documentToClassId(source)), Supply_1.Supply.schema.externalId.valueOfField(source), Supply_1.Supply.schema.productId.valueOf(conversions.toClassReferenceId(source.productId)), Supply_1.Supply.schema.siteId.valueOf(conversions.toClassReferenceId(source.siteId)), Supply_1.Supply.schema.transactionId.valueOf(conversions.toClassReferenceId(source.transactionId)), Supply_1.Supply.schema.availableSupply.valueOf(conversions.asObject(source, 'availableSupply', ValueWithUnitConverter_1.ValueWithUnitConverter.deserialize(conversions))), Supply_1.Supply.schema.physicalSupply.valueOf(conversions.asObject(source, 'physicalSupply', ValueWithUnitConverter_1.ValueWithUnitConverter.deserialize(conversions))), Supply_1.Supply.schema.physicalSupplyValue.valueOf(conversions.asObject(source, 'physicalSupplyValue', conversions.toBigNumber)), conversions.asFlagSet(source.stateFlags, EntityStateFlag_1.EntityStateFlag));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, conversions.classToDocumentId(source));
      Object.assign(result, {
        externalId: source.externalId,
        productId: conversions.toDocumentReferenceId(source.productId),
        siteId: conversions.toDocumentReferenceId(source.siteId),
        transactionId: conversions.toDocumentReferenceId(source.transactionId),
        availableSupply: conversions.asObject(source, 'availableSupply', ValueWithUnitConverter_1.ValueWithUnitConverter.serialize(conversions)),
        physicalSupply: conversions.asObject(source, 'physicalSupply', ValueWithUnitConverter_1.ValueWithUnitConverter.serialize(conversions)),
        physicalSupplyValue: conversions.fromBigNumber(source.physicalSupplyValue),
        stateFlags: source.stateFlags.serialize()
      });
      return result;
    }
  }]);

  return SupplyConverterImpl;
}(SupplyConverter_1.SupplyConverter);

exports.SupplyConverterImpl = SupplyConverterImpl;